module.exports = __webpack_public_path__ + "static/media/nz.1d5f4598.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nz.svg
// module id = 2181
// module chunks = 0